import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Font2Xl extends ITextBoxProps {}

export const TextBoxMaxLine1Font2Xl = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Font2xl,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Font2Xl): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
